import { createFileRoute } from "@tanstack/react-router"
import { AnnouncementDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/$announcementUuid/$tabKey"
)({
  component: function AnnouncementTabRoute() {
    return (
      <AuthorizationGate resource={Resource.ANNOUNCEMENT} action={Action.READ}>
        <AnnouncementDetailPage />
      </AuthorizationGate>
    )
  },
})
